var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact"},[_c('base-button',{attrs:{"is-link":"","target":"_blank","href":_vm.getLink,"icon":_vm.$t(_vm.getIcon)}},[_vm._v(" "+_vm._s(_vm.getValue)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }